const ElementUseCategories = () => import('../views/admin/elementUseCategories/ElementUseCategories.vue')
const ElementUseCategoryForm = () => import('../views/admin/elementUseCategories/ElementUseCategoryForm.vue')

const ElementUseRankings = () => import('../views/admin/elementUseRankings/ElementUseRankings.vue')
const ElementUseRankingForm = () => import('../views/admin/elementUseRankings/ElementUseRankingForm.vue')

export default [
  {
    path: 'elementUseCategories',
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: ElementUseCategories
  },
  {
    path: 'elementUseCategories/:id',
    props: true,
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: ElementUseCategoryForm
  },
  {
    path: 'elementUseRankings',
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: ElementUseRankings
  },
  {
    path: 'elementUseRankings/:id',
    props: true,
    meta: {
      requiresAuthStatus: 'admin'
    },
    component: ElementUseRankingForm
  }
]
